import { Event } from "./Event.js";
/**
 * A list associated with an event query.
 *
 * @public
 */
export class EventList {
    constructor(book, payload) {
        this.book = book;
        this.payload = payload || {};
    }
    /**
     * Gets the cursor associated with the query for pagination.
     *
     * @returns The cursor associated with the query for pagination
     */
    getCursor() {
        return this.payload.cursor;
    }
    /**
     * Gets the first Event in the list.
     *
     * @returns The first Event in the list
     */
    getFirst() {
        const events = this.getItems();
        return events.length > 0 ? events[0] : undefined;
    }
    /**
     * Get the total number of events in the list.
     *
     * @returns The total number of events
     */
    size() {
        var _a;
        return ((_a = this.payload.items) === null || _a === void 0 ? void 0 : _a.length) || 0;
    }
    /**
     * Get the events in the list.
     *
     * @returns An array of Event objects
     */
    getItems() {
        var _a;
        return ((_a = this.payload.items) === null || _a === void 0 ? void 0 : _a.map(event => new Event(this.book, event))) || [];
    }
}
//# sourceMappingURL=EventList.js.map